import React, { PropsWithChildren } from 'react';
import { ThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Provider as ReduxProvider } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ruLocale from 'date-fns/locale/ru';
import { I18nextProvider } from 'react-i18next';
import { theme } from 'theme/theme';
import store from 'store/store';
import SnackbarProvider from 'components/atoms/SnackbarProvider/SnackbarProvider';
import ConfirmProvider from 'components/atoms/ConfirmProvider/ConfirmProvider';
import i18n from './assets/i18n/i18n';
import MainRoute from './router/MainRoute';

const app: React.FC<PropsWithChildren<any>> = () => {
    return (
        <ReduxProvider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                    <I18nextProvider i18n={i18n}>
                        <SnackbarProvider>
                            <ConfirmProvider>
                                <MainRoute />
                            </ConfirmProvider>
                        </SnackbarProvider>
                    </I18nextProvider>
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </ReduxProvider>
    );
};

export default app;
